<template>
  <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50">
    <!-- Modals -->
    <ExamineeAddModal
      id="addExamineeModal"
      :clientId="clientId || 0"
      :creditGroupList="creditGroupList"
      :nonActiveExamineeCount="nonActiveExamineeCount"
      :examineesList="examineeList"
      @ok="getExamineesOfClient"
    ></ExamineeAddModal>

    <ExamineeReportModal
      id="reportExamineeModal"
      :clientId="clientId || 0"
      :examineeList="examineeList"
      ref="reportExamineeModal"
    ></ExamineeReportModal>

    <template v-slot:header>
      <h6 class="m-0 font-weight-bold">Examinees - {{ examineeList ? examineeList.length : 0 }}</h6>
    </template>

    <!-- Controls -->
    <b-card-text>
      <b-card-group class="children-mr-2 mb-2">
        <b-button
          v-b-modal.addExamineeModal
          @click="showAddExamineeModal"
          variant="primary"
          size="sm"
          class="bg-site-primary"
        >Add Examinees</b-button>
        <b-button
          variant="primary"
          size="sm"
          class="bg-site-primary"
          @click="showExamineeReportModal"
        >Export Examinees to CSV</b-button>
        <b-button
          variant="primary"
          size="sm"
          class="bg-site-primary"
          @click="showExamineeAnswersReportModal"
          v-if="!restrictedMode"
        >Export Examinee Answers to CSV</b-button>
      </b-card-group>
    </b-card-text>

    <!-- Examinees -->
    <b-card-text>
      <b-table
        hover
        sticky-header
        :items="examineeList"
        primary-key="id"
        tbody-tr-class="cursor-pointer"
        :fields="[
          {
            key: 'id',
            label: 'ID',
            sortable: true
          },
          {
            key: 'user.username',
            label: 'Username',
            sortable: true
          },
          {
            key: 'rawPassword',
            label: 'Password',
            sortable: true
          },
          {
            key: 'name',
            label: 'Name',
            sortable: true
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true
          },
          {
            key: 'createdAt',
            label: 'Date Created',
            sortable: true
          },
          {
            key: 'expiry',
            label: 'Expiry',
            sortable: true
          },
          {
            key: 'action',
            label: '',
            sortable: false
          },
        ]"
      >
        <template v-slot:cell(name)="data">
          <small v-if="data.item.lastName && data.item.firstName">{{ `${data.item.lastName }, ${data.item.firstName} ${data.item.middleInitial} `}}</small>
          <small v-else>Not Submitted</small>
        </template>
        <template v-slot:cell(createdAt)="data">
          <small>{{ new Date(data.item.createdAt)}}</small>
        </template>
        <template v-slot:cell(expiry)="data">
          <small>{{ new Date(data.item.expiry)}}</small>
        </template>
        <template v-slot:cell(action)="data">
          <b-button v-if="data.item.status == 'locked'" @click="unlockExaminee(data.item.id)">Unlock</b-button>
        </template>
      </b-table>
    </b-card-text>
  </b-card>
</template>

<script>
import ExamineeAddModal from "./ExamineeAddModal";
import ExamineeReportModal from "./ExamineeReportModal";
export default {
  name: `ExamineeList`,
  components: {
    ExamineeAddModal,
    ExamineeReportModal,
  },
  data() {
    return {
      examineeList: null,
      creditGroupList: null
    };
  },
  props: {
    clientId: String,
    restrictedMode: Boolean,
  },
  computed: {
    nonActiveExamineeCount() {
      let examineeList = this.examineeList || [];
      var count = 0;
      examineeList.forEach((examinee) => {
        if (examinee.status != `created`) count++;
      });
      return count;
    },
  },
  mounted() {
    this.getExamineesOfClient();
    this.getCreditGroupsOfClient();
  },
  methods: {
    getExamineesOfClient() {
      const clientId = this.clientId;
      if (!clientId || isNaN(clientId)) {
        this.$router.push("../");
      } else {
        this.$store
          .dispatch("examinee/getAllOfClientSimple", { clientId })
          .then((data) => (this.examineeList = data.data));
      }
    },
    getCreditGroupsOfClient() {
      const clientId = this.clientId;
      if (!clientId || isNaN(clientId)) {
        this.$router.push("../");
      } else {
        this.$store
          .dispatch("creditGroup/getAllOfClient", { clientId })
          .then((data) => (this.creditGroupList = data.data));
      }
    },
    showAddExamineeModal(){
      this.getCreditGroupsOfClient();
      this.$bvModal.show(`addExamineeModal`)
    },
    unlockExaminee(examineeId) {
      this.$store
        .dispatch("examinee/update", {
          id: examineeId,
          data: { status: "personalinfogiven" },
        })
        .then(() => {
          this.getExamineesOfClient();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showExamineeReportModal() {
      this.$refs.reportExamineeModal.dispatchPath = "examinee/getAllByIdFlat"
      this.$bvModal.show('reportExamineeModal')
    },
    showExamineeAnswersReportModal() {
      this.$refs.reportExamineeModal.dispatchPath = "examineeAnswer/getAllOfExaminees"
      this.$bvModal.show('reportExamineeModal')
    },
  },
};
</script>

<style lang="scss" scoped>
</style>